import { render } from "./CatalogProducts.vue?vue&type=template&id=03f2bf04"
import script from "./CatalogProducts.vue?vue&type=script&lang=js"
export * from "./CatalogProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__